import { ProductType } from "../../interfaces/ProductProperties/ProductPropertiesRelated";
import TrackingMeta from "../../interfaces/Tracking/TrackingMeta";
import { TrackingVariantETracker } from "../../interfaces/Tracking/TrackingVariantETracker";
import { TrackingVariantICE } from "../../interfaces/Tracking/TrackingVariantICE";

export default class TrackingHandler {
    static handleTracking(trackingMeta: TrackingMeta, data: Record<string, unknown>) {
        // console.log('trackingMeta: ', trackingMeta)
        switch (trackingMeta.variant) {
            // TrackingVariantICE
            case TrackingVariantICE.ADDTOCART:
                return this.handleTrackingVariantICEAddToCart(data);

            // TrackingVariantETracker
            case TrackingVariantETracker.SENDORDER:
                return this.handleTrackingVariantETrackerSendOrder(data);
            case TrackingVariantETracker.INSERTTOBASKET:
                return this.handleTrackingVariantETrackerInsertToBasket(data);
            case TrackingVariantETracker.WATCHSTEP:
                return this.handleTrackingVariantETrackerStepWatcher(data);

            default:
                console.error('TrackingHandler: No trackingVariant defined', trackingMeta);
                break;
        }
    }

    //#region "TrackingVariantICE"
    static handleTrackingVariantICEAddToCart(data: Record<string, unknown>) {
        console.log("event", {
            name: "Add to Cart",
            properties: data
        });
        window.DY && window.DY.API && window.DY.API("event", {
            name: "Add to Cart",
            properties: data
        });
    }
    //#endregion "TrackingVariantICE"

    //#region "TrackingVariantETracker"
    static handleTrackingVariantETrackerSendOrder(data: Record<string, unknown>) {
        // console.log("order", data);
        window.etCommerce && window.etCommerce.sendEvent('order', data);
        window._etracker && window._etracker.sendEvent(new window.et_ClickEvent('Bestellen', '{Product Name}'));
    }

    static handleTrackingVariantETrackerInsertToBasket(data: Record<string, unknown>) {
        const quantity = data.quantity;
        delete data.quantity;

        console.log("insertToBasket", {
            data,
            quantity
        });
        window.etCommerce && window.etCommerce.sendEvent('insertToBasket', data, quantity);
        if (data && data.category && (data.category as Array<string>).length > 0) {
            if((data.category as Array<string>)[0] as ProductType === ProductType.TEST) {
                window._etracker && window._etracker.sendEvent(new window.et_ClickEvent('btnTestInDenWarenkorb', data.name));
            } else {
                window._etracker && window._etracker.sendEvent(new window.et_ClickEvent('btnKaufInDenWarenkorb', data.name));
            }
        }
    }

    static handleTrackingVariantETrackerStepWatcher(data: Record<string, unknown>) {
        // console.log("watcher", data);
        console.log('builded string: ', `${(data.pageType as string).toUpperCase()}-${data.step}`)
        window._etracker && window._etracker.sendEvent(new window.et_ClickEvent(`${(data.pageType as string).toUpperCase()}-${data.step}`, `${data.campaignId}`));
    }
    //#endregion "TrackingVariantETracker"
}